import { Container } from './styles.ts';
import { Description, OwnerImage } from './components/index.ts';

export function AboutCard() {
  return (
    <Container gap="20">
      <OwnerImage />
      <Description />
    </Container>
  );
}
